import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

export default function Alert({
  alertControl = {
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  },
  setAlertControl
}) {
  if (!alertControl.open) { return null }
  return (
    <SweetAlert
      success={alertControl.status === 'success' ? true : false}
      warning={alertControl.status === 'warning' ? true : false}
      error={alertControl.status === 'error' ? true : false}
      title={alertControl.title}
      onConfirm={() => setAlertControl({ ...alertControl, open: false })}
    >
      {alertControl.message}
    </SweetAlert>
  )
}
